import React, { useState, useEffect, useRef } from 'react'
import AdminHeader from '../layout/AdminHeader';
import { FiSearch } from "react-icons/fi";
import '../assets/css/admin-toolbar.css';
import { toast } from 'react-toastify';
import { GoTrash } from "react-icons/go";
import { FaRegEdit } from "react-icons/fa";
import { apiCallingPost } from "../api/services"
import noData from "../assets/images/no-data.png"
import Loader from "../assets/images/loader.gif"
import TagDirectoryEdit from './tag-directory-edit';
import TagDirectoryDelete from './Tag-directory-delete';
import { setTagList } from '../redux/reducers/commonSlice';
import { MdFindReplace } from 'react-icons/md';

function TagDirectory() {
  const [mediaListFlag, setMediaListFlag] = useState(false)
  const [tagDirectoryList, setTagDirectoryList] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [activeLetters, setActiveLetters] = useState(["All"]);
  const ITEMS_PER_PAGE = 500; 
  const [tagPopup, setTagPopup] = useState(false)
  const [updateTag, setUpdateTag] = useState("");
  const [selectTagList, setSelectTagList] = useState([]);
  const wrapperRef = useRef(null);
  const loadMoreRef = useRef(null);
  const letters = ["All", ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];
  const [tagDeletePopup, setTagDeletePopup] = useState(false)
  const [videoDetails, setVideoDetails] = useState([])
  const [findTagFlag, setFindTagFlag] = useState(false);
  const [findTag, setFindTag] = useState("");

  useEffect(() => {
    const handleEvents = (event) => {
      if (event.type === 'keydown' && event.key === 'Escape') {
        cancelPopup();
      }
      if (
        event.type === 'mousedown' &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        cancelPopup();
      }
    };

    document.addEventListener('keydown', handleEvents);
    document.addEventListener('mousedown', handleEvents);

    return () => {
      document.removeEventListener('keydown', handleEvents);
      document.removeEventListener('mousedown', handleEvents);
    };
  }, [])

  useEffect(() => {
    TagDirectoryList(0, false);
  }, [searchText, activeLetters]);

  const hasMore = tagDirectoryList.length < totalCount;

  useEffect(() => {
    if (!hasMore || loading || loadingMore || tagDirectoryList.length === 0) return;
    const sentinel = loadMoreRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          const currentLength = tagDirectoryList.length;
          if (currentLength < totalCount && !loading && !loadingMore) {
            TagDirectoryList(currentLength, true);
          }
        }
      },
      { root: null, rootMargin: '150px', threshold: 0 }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [tagDirectoryList.length, totalCount, hasMore, loading, loadingMore]);

  const TagDirectoryList = async (offset = 0, isLoadMore = false) => {
    if (isLoadMore) {
      setLoadingMore(true);
    } else {
      setLoading(true);
    }
    const startLetters = activeLetters.includes("All") ? [] : activeLetters;
    let postData = {
      search_text: searchText.trim(),
      offset: offset,
      max: ITEMS_PER_PAGE
    };
    if (startLetters.length > 0) {
      postData.start_letters = startLetters;
    }
    try {
      const response = await apiCallingPost("api/tag_directory/get_tags", postData);
      const { data } = response;
      if (data.success === "1") {
        const tags = data.result?.tags || [];
        const count = data.result?.total_count ?? data.total_count ?? 0;
        setTotalCount(Number(count));
        setTagDirectoryList(prev => isLoadMore ? [...prev, ...tags] : tags);
      } else {
        if (!isLoadMore) {
          setTagDirectoryList([]);
          setTotalCount(0);
        }
      }
    } catch (error) {
      console.error("Error fetching tag update directory:", error);
      if (!isLoadMore) {
        setTagDirectoryList([]);
        setTotalCount(0);
      }
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handleLetterClick = (letter) => {
    setSearchText("")
    if (letter === "All") {
      if (activeLetters.includes("All")) {
        setActiveLetters([]);
      } else {
        setActiveLetters(["All"]);
      }
    } else {
      let updated = [...activeLetters];
      updated = updated.filter(list => list !== "All");

      if (updated.includes(letter)) {
        updated = updated.filter(list => list !== letter);
      } else {
        updated.push(letter);
      }
      if (updated.length === 0) {
        updated = ["All"];
      }
      setActiveLetters(updated);
    }
  }

  const cancelPopup = () => {
    setTagPopup(false)
    setTagDeletePopup(false)
    setFindTagFlag(false)
    setUpdateTag("")
    setFindTag("")
    setVideoDetails([])
  }

  const TagVideoDetails = async (tagNames) => {
    
    let postData = {
      tag_name: tagNames
    }
   
    try {
      const response = await apiCallingPost("api/tag_directory/get_video_by_tag", postData);
      const { data } = response;
      
      if (data.success === "1") {
        setVideoDetails(data.result);
      }
      else {
        setVideoDetails([])
      }
    } catch (error) {
      console.error("Error fetching  Tag video details:", error);

    }
  }

  const selectIds = (tagName) => {
    setSelectTagList((prev) => {
      if (prev.includes(tagName)) {
        return prev.filter(tag => tag !== tagName)
      } else {
        return [...prev, tagName]
      }
    })
  }

  return (
    <div className='main-wrapper main-wrapper-cms'>
      <AdminHeader title="Tag Directory" setMediaListFlag={setMediaListFlag} />
      <div className="admin-toolbar">
        <div className="container">
          <div className="admin-toolbar-search">
            <FiSearch className='search-input-icon' />
            <input type='text' className='search-input' placeholder='Tag Directory Search'
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)} />
          </div>
          <div className="admin-toolbar-actions">
            <button
              type="button"
              className="accept-all-btn accept-all-danger"
              disabled={selectTagList.length === 0}
              onClick={() => {
                setTagDeletePopup(true);
                TagVideoDetails(selectTagList);
              }}
            >
              <GoTrash /> Delete
            </button>
            <button
              type="button"
              className="accept-all-btn"
              onClick={() => {
                setTagPopup(true);
                setFindTagFlag(true);
              }}
            >
              <MdFindReplace size={18} /> Find And Replace
            </button>
          </div>
        </div>
      </div>
      <div className="container my-3">
        <div className='tag-listing-filter-outer'>
          <div className='tag-listing-filter'>
            {letters.map((letter, index) => (
              <div
                key={index}
                className={`tag-listing-inner-filter ${activeLetters.includes(letter) ? 'active' : ''}`}
                onClick={() => handleLetterClick(letter)}
              >
                {letter}
              </div>
            ))}
          </div>
        </div>
        <div className='row'>
          <div className='tag-listing'>
            {loading ? (
              <div className="noData d-flex flex-column w-100" style={{ minHeight: 'unset' }}>
                <div>
                  <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
              </div>
            ) : tagDirectoryList.length > 0 ? (
              <>
                {tagDirectoryList.map((tag, index) => (
                  <div key={index} className={`tag-list ${selectTagList.includes(tag) ? 'selected' : ``}`}>
                    <div className='tag-list-name'
                      onClick={() => selectIds(tag)}
                    >
                      {tag}
                    </div>

                    <GoTrash className='tag-list-delete'
                      onClick={(e) => {
                        setTagDeletePopup(true)
                        setSelectTagList([tag])
                        TagVideoDetails([tag])
                      }}
                    />
                    <FaRegEdit className='tag-list-edit'
                      onClick={(e) => {
                        setTagPopup(true)
                        setUpdateTag(tag)
                        TagVideoDetails([tag])
                      }}
                    />
                  </div>
                ))}
                {hasMore && <div ref={loadMoreRef} className="text-center py-3 w-100" style={{ minHeight: '50px' }}>{loadingMore && <img src={Loader} alt="loading" width={40} height={40} />}</div>}
              </>
            ) : (
              <div className="noData d-flex flex-column w-100" style={{ minHeight: 'unset' }}>
                <div>
                  <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
                <div>No Data Available</div>
              </div>
            )}
          </div>
        </div>
      </div>
      {tagPopup &&
        <TagDirectoryEdit cancelPopup={cancelPopup} wrapperRef={wrapperRef} videoDetails={videoDetails}
          updateTag={updateTag} setUpdateTag={setUpdateTag} TagDirectoryList={TagDirectoryList} setTagPopup={setTagPopup}
          findTag={findTag} setFindTag={setFindTag} findTagFlag={findTagFlag} setFindTagFlag={setFindTagFlag}
          TagVideoDetails={TagVideoDetails} />
      }
      {tagDeletePopup &&
        <TagDirectoryDelete cancelPopup={cancelPopup} wrapperRef={wrapperRef} videoDetails={videoDetails}
          selectTag={selectTagList} TagDirectoryList={TagDirectoryList} setTagDeletePopup={setTagDeletePopup} />
      }
    </div>
  )
}

export default TagDirectory